import React, { useCallback, useState, useRef } from 'react';
import cn from 'classnames';
import Container from 'components/UI/Container';
import Title from 'components/UI/Title';
import Slider from 'components/UI/Slider';
import { CustomDot, CustomPagination } from 'components/UI/Slider/utils';
import ReviewInfo from './ReviewInfo';
import { useTrans } from 'utils/localisation';

import * as styles from './CustomTestimonials.module.scss';

export default function CustomTestimonials({ items, className }) {
  const t = useTrans(['testimonials']);
  const sliderRef = useRef(null);
  const [current, setCurrent] = useState(0);

  const setCurrentKey = useCallback((prev, next) => {
    setCurrent(next);
  }, []);

  const settings = {
    customPaging: CustomDot.bind(null, items?.length, current),
    appendDots: CustomPagination,
    dotsClass: 'slick-pagination',
    dots: true,
    infinite: false,
    variableWidth: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
  };

  const canScrollLeft = current > 0;
  const canScrollRight = current < items.length - 1;

  const toggleNext = () => {
    sliderRef.current.slickNext();
  };

  const togglePrev = () => {
    sliderRef.current.slickPrev();
  };

  return (
    <Container background="transparent" className={cn(styles.container, className)}>
      <div className={styles.wrapper}>
        <div className={styles.topRow}>
          <Title tag="h2" size="h3" color="white">
            {t('customTestimonialsTitle')}
          </Title>
          <div className={styles.sliderControls}>
            <button
              onClick={togglePrev}
              className={styles.buttonLeft}
              disabled={!canScrollLeft}
              aria-label="Previous Slide"
            />
            <button
              onClick={toggleNext}
              className={styles.buttonRight}
              disabled={!canScrollRight}
              aria-label="Next Slide"
            />
          </div>
        </div>
        <Slider
          className={cn(styles.sliderContainer, 'defaultSlider')}
          {...settings}
          beforeChange={setCurrentKey}
          ref={sliderRef}
        >
          {items.map((item, i) => (
            <ReviewInfo key={i} {...item} />
          ))}
        </Slider>
      </div>
    </Container>
  );
}
